import { FontRootNamesEnum as t } from "../enums/font-root-names-enum.mjs";
import { ThemeRootNamesEnum as o } from "../enums/theme-root-names-enum.mjs";
import { getColors as n } from "./color-utils.mjs";
const u = (r) => {
  const {
    primaryColor: e,
    secondaryColor: a,
    tertiaryColor: l,
    textColorPrimary: y,
    textColorSecondary: c,
    borderColorTertiary: m
  } = n(r);
  return `
  :root {
      /* Colors */
      /* Default primary color */
      ${o.primaryColor}: ${e}; /* Default primary color */

      /* Default secondary color */
      ${o.secondaryColor}: ${a}; /* Default secondary color */

      /* Default background color */
      ${o.tertiaryColor}: ${l}; /* Default background color */

      /* Default text primary color */
      ${o.textColorPrimary}: ${y}; /* Default text primary color */
      ${o.textColorSecondary}: ${c}; /* Default text secondary color */
      ${o.borderColorTertiary}: ${m}; /* Default border tertiry color */
      
      /* Fonts */
      ${t.primaryFont}: ${r.primaryFont};
      ${t.secondaryFont}: ${r.secondaryFont};
  }
  `;
};
export {
  u as getRootDesignCss
};
